module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-07.cde99d6f.png";